import api from "./api";

// ── Pause / Resume ──

export const pauseTicket = async (ticketId, data) => {
  const response = await api.post(`/tickets/${ticketId}/pause`, data);
  return response.data;
};

export const resumeTicket = async (ticketId) => {
  const response = await api.post(`/tickets/${ticketId}/resume`);
  return response.data;
};

// ── List paused tickets ──

export const listPausedTickets = async (params = {}) => {
  const response = await api.get("/tickets-paused", { params });
  return response.data;
};

// ── Pause logs ──

export const listPauseLogs = async (ticketId) => {
  const response = await api.get(`/tickets/${ticketId}/pause-logs`);
  return response.data;
};

// ── Pause Reasons CRUD ──

export const listPauseReasons = async (onlyActive = true) => {
  const response = await api.get("/ticket-pause-reasons", {
    params: { onlyActive }
  });
  return response.data;
};

export const createPauseReason = async (data) => {
  const response = await api.post("/ticket-pause-reasons", data);
  return response.data;
};

export const updatePauseReason = async (id, data) => {
  const response = await api.put(`/ticket-pause-reasons/${id}`, data);
  return response.data;
};

export const deletePauseReason = async (id) => {
  const response = await api.delete(`/ticket-pause-reasons/${id}`);
  return response.data;
};
